import React, { useCallback, useState, useEffect } from 'react';
import classNames from 'classnames';

import './ResolveLoader.styles.scss';
import './ResolveLoader.styles.responsive.scss';

type OverlayColor = 'transparent' | 'pink';

type ResolveLoaderProps = {
  className?: string;
  progress?: number;
  withBreakpoints?: boolean;
  overlayColor?: OverlayColor;
};

const TEXT_RATIO = {
  x: 1050,
  y: 225,
};

const BREAKPOINTS = [0, 17, 32, 44, 61, 68, 83.5, 100]; // for "Resolve" string

const percentageIncrement = 10;

const ResolveLoader: React.FC<ResolveLoaderProps> = (props) => {
  const {
    className,
    progress,
    withBreakpoints = true,
    overlayColor = 'pink',
  } = props;

  const classes = classNames('resolve-loader', overlayColor, className);

  const setPercentageToBreakpoint = useCallback((percentage: number) => {
    const index = BREAKPOINTS.findIndex(
      (breakpoint) => breakpoint > percentage,
    );

    return BREAKPOINTS[index - 1];
  }, []);

  const [percentage, setPercentage] = useState(
    (progress && withBreakpoints
      ? setPercentageToBreakpoint(progress)
      : progress) || 0,
  );

  useEffect(() => {
    if (progress) return;
    if (percentage >= 100) return;

    const timeout = setTimeout(
      () =>
        setPercentage((old) =>
          withBreakpoints
            ? BREAKPOINTS[BREAKPOINTS.indexOf(old) + 1]
            : old + percentageIncrement,
        ),
      80,
    );

    return () => clearTimeout(timeout);
  }, [percentage, progress, withBreakpoints]);

  return (
    <div className={classes}>
      <div className="resolve-loader__content">
        <svg viewBox={`0 0 ${TEXT_RATIO.x} ${TEXT_RATIO.y}`}>
          <text
            y={`${TEXT_RATIO.y}`}
            fontSize={`${TEXT_RATIO.y + 60}`}
            height={`${TEXT_RATIO.y}`}
            letterSpacing={5}
          >
            Resolve
          </text>
        </svg>
        <svg
          viewBox={`0 0 ${TEXT_RATIO.x} ${TEXT_RATIO.y}`}
          style={{
            clipPath: `polygon(0% 0%, ${percentage}% 0%, ${percentage}% 100%, 0% 100%)`,
          }}
        >
          <text y="224" fontSize={`${TEXT_RATIO.y + 60}`} letterSpacing={5}>
            Resolve
          </text>
        </svg>
      </div>
    </div>
  );
};

export default ResolveLoader;
